export default function isEmptyHtmlContent(content: string) {
  return content.replace(/<[^>]*>/g, "").trim().length === 0;
}
